import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, AlertTriangle } from "lucide-react";
import { Logo } from "@/components/landing/Navbar";

const sections = [
  {
    n: 1,
    title: "Objet",
    body: [
      "Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'usage de l'application mobile Jos'FIT (l'« Application ») proposée par l'éditeur (le « Service »).",
      "En téléchargeant, installant ou utilisant l'Application, vous (l'« Utilisateur ») acceptez sans réserve l'intégralité des présentes CGU.",
    ],
  },
  {
    n: 2,
    title: "Description du service",
    body: [
      "Jos'FIT est un outil de SUIVI PERSONNEL en santé et nutrition. Il propose notamment :",
    ],
    list: [
      "Suivi alimentaire (recherche d'aliments, journal des repas, macros et calories)",
      "Module Glycémie pour personnes diabétiques (timeline, cibles, rappels)",
      "Module Cycle Féminin (suivi menstruel, symptômes, périodes)",
      "Coach IA conversationnel (Coach Luna)",
      "Exports PDF (journal quotidien, hebdomadaire, rapports médicaux)",
      "Intégrations capteurs santé (Apple Health, Health Connect)",
    ],
  },
  {
    n: 3,
    title: "Avertissement médical important",
    highlight: true,
    body: [
      "Jos'FIT n'est PAS un dispositif médical et n'a pas vocation à établir de diagnostic.",
      "L'Application NE remplace EN AUCUN CAS l'avis d'un médecin, d'un diététicien ou de tout professionnel de santé.",
      "Les données affichées (calories recommandées, cibles glycémiques, prédictions de cycle…) sont indicatives. Consultez toujours votre médecin pour des recommandations personnalisées.",
      "En cas d'urgence médicale (hypoglycémie sévère, douleurs aiguës…), contactez immédiatement les services d'urgence (15 — SAMU en France).",
    ],
  },
  {
    n: 4,
    title: "Accès et compte",
    body: [
      "L'Application fonctionne en mode local. Aucun compte central n'est requis pour utiliser les fonctionnalités de base. L'ensemble des données de suivi sont stockées localement sur votre appareil.",
      "Un identifiant anonyme généré aléatoirement peut être utilisé pour la gestion des abonnements et les statistiques anonymes (uniquement avec votre consentement).",
      "Vous êtes seul responsable de la confidentialité de votre appareil et des données qu'il contient.",
    ],
  },
  {
    n: 5,
    title: "Abonnement Premium",
    body: ["Trois formules sont proposées :"],
    list: [
      "Gratuit : recherche aliments, tracking macros, suivi glycémie complet (sans engagement)",
      "BYOK Premium — 1,20€/mois : tout Premium en utilisant votre propre clé Gemini",
      "Premium Clé en main — 3,99€/mois : expérience complète avec clé fournie",
    ],
    after: [
      "Les paiements sont gérés par les plateformes App Store (Apple) et Google Play (Google). Aucune donnée bancaire n'est collectée ni stockée par Jos'FIT.",
    ],
  },
  {
    n: 6,
    title: "Renouvellement automatique et résiliation",
    body: [
      "Les abonnements mensuels se renouvellent automatiquement à la fin de chaque période, sauf annulation au moins 24 heures avant la fin de la période en cours.",
      "Pour annuler :",
    ],
    list: [
      "iOS : Réglages → Identifiant Apple → Abonnements → Jos'FIT",
      "Android : Play Store → Compte → Abonnements → Jos'FIT",
    ],
    after: [
      "L'annulation prend effet à la fin de la période en cours. Aucun remboursement n'est dû pour la période déjà entamée. Les demandes de remboursement exceptionnelles sont à adresser directement à Apple ou Google selon la plateforme d'achat.",
    ],
  },
  {
    n: 7,
    title: "Propriété intellectuelle",
    body: [
      "L'Application, ses contenus, codes sources, marques, logos et interfaces sont la propriété exclusive de l'éditeur, protégés par les lois en vigueur sur la propriété intellectuelle.",
      "Aucune reproduction, copie, modification ou redistribution n'est autorisée sans accord écrit préalable.",
      "Les données alimentaires sont fournies par OpenFoodFacts sous licence ODbL.",
    ],
  },
  {
    n: 8,
    title: "Données de l'Utilisateur",
    body: [
      "L'Utilisateur reste propriétaire de l'intégralité des données saisies (journal alimentaire, mesures glycémiques, cycle, profil…).",
      "Ces données sont stockées localement sur l'appareil. Une fonctionnalité d'export (.json) permet de les sauvegarder à tout moment.",
      "La désinstallation de l'Application entraîne la suppression définitive des données locales. Pensez à exporter au préalable.",
    ],
  },
  {
    n: 9,
    title: "Limitation de responsabilité",
    body: [
      "L'éditeur s'efforce de fournir une application fiable mais ne peut garantir l'absence d'erreurs, d'interruptions de service ou d'inexactitudes dans les données affichées.",
      "L'Utilisateur reconnaît utiliser l'Application sous sa seule responsabilité. L'éditeur ne saurait être tenu responsable de toute décision médicale ou de toute conséquence liée à l'usage de l'Application.",
      "En aucun cas la responsabilité de l'éditeur ne pourra excéder le montant total des sommes versées par l'Utilisateur au titre de son abonnement sur les 12 derniers mois.",
    ],
  },
  {
    n: 10,
    title: "Modifications des CGU",
    body: [
      "L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Toute modification substantielle sera notifiée via l'Application au prochain démarrage.",
      "La poursuite de l'usage après notification vaut acceptation des nouvelles CGU.",
    ],
  },
  {
    n: 11,
    title: "Loi applicable et juridiction",
    body: [
      "Les présentes CGU sont régies par le droit français. Tout litige relatif à leur interprétation ou exécution relève de la compétence exclusive des tribunaux français.",
      "Conformément à la législation européenne, l'Utilisateur peut recourir à la plateforme de règlement en ligne des litiges : https://ec.europa.eu/consumers/odr/",
    ],
  },
  {
    n: 12,
    title: "Contact",
    body: [
      "Toute question relative aux présentes CGU peut être adressée à l'éditeur via la fonction « Aide & Support » du Profil de l'Application.",
    ],
  },
];

const Paragraph = ({ text }) => {
  const parts = text.split(/(https?:\/\/[^\s]+)/g);
  return (
    <p className="text-slate-400 leading-relaxed">
      {parts.map((p, i) =>
        p.match(/^https?:\/\//) ? (
          <a
            key={i}
            href={p}
            target="_blank"
            rel="noopener noreferrer"
            className="text-emerald-400 underline underline-offset-2 break-all hover:text-emerald-300"
          >
            {p}
          </a>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </p>
  );
};

export default function CGU() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#080A09] font-dm-sans">
      <header className="sticky top-0 z-50 bg-[#080A09]/80 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="cgu-logo">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="cgu-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="relative">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-[400px] w-[400px] rounded-full bg-emerald-500/10 blur-3xl" />

        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 pt-20 pb-28">
          <div className="text-center" data-testid="cgu-header">
            <h1 className="font-outfit text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
              Conditions d'utilisation
            </h1>
            <p className="mt-4 text-lg text-slate-400">
              Les règles qui encadrent votre usage de Jos'FIT.
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs font-semibold">
              <span className="rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-1.5 text-emerald-300">
                Version 1.0
              </span>
              <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-slate-400">
                Mise à jour · 15 juin 2025
              </span>
            </div>
          </div>

          <div className="mt-10 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-8">
            <p className="text-slate-300 leading-relaxed">
              En utilisant Jos'FIT, vous acceptez les présentes Conditions
              Générales d'Utilisation. Merci de les lire attentivement — elles
              décrivent vos droits et obligations.
            </p>
          </div>

          <div className="mt-10 space-y-10">
            {sections.map((s) => (
              <section key={s.n} data-testid={`cgu-section-${s.n}`}>
                <div className="flex items-center gap-4">
                  <span
                    className={`grid place-items-center h-9 w-9 shrink-0 rounded-full font-outfit font-bold text-sm ${
                      s.highlight
                        ? "bg-amber-500/15 text-amber-400 ring-1 ring-amber-400/30"
                        : "bg-emerald-400 text-emerald-950"
                    }`}
                  >
                    {s.n}
                  </span>
                  <h2 className="font-outfit text-xl sm:text-2xl font-bold text-white">
                    {s.title}
                  </h2>
                </div>

                <div
                  className={`mt-4 ml-0 sm:ml-[3.25rem] space-y-3 ${
                    s.highlight
                      ? "rounded-2xl border border-amber-400/25 bg-amber-500/[0.06] p-6"
                      : ""
                  }`}
                >
                  {s.highlight && (
                    <div className="flex items-center gap-2 text-amber-400 font-semibold">
                      <AlertTriangle className="h-5 w-5" />
                      À lire absolument
                    </div>
                  )}
                  {s.body?.map((p, i) => (
                    <Paragraph key={i} text={p} />
                  ))}
                  {s.list && (
                    <ul className="space-y-2 pt-1">
                      {s.list.map((li, i) => (
                        <li key={i} className="flex gap-3 text-slate-400">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
                          <span>{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.after?.map((p, i) => (
                    <Paragraph key={`a-${i}`} text={p} />
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link
              to="/"
              data-testid="cgu-footer-back"
              className="inline-flex items-center gap-2 rounded-full bg-emerald-400 px-7 py-3 text-sm font-bold text-emerald-950 hover:bg-emerald-300 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Retour à l'accueil
            </Link>
            <p className="mt-8 text-sm text-slate-500">
              © {new Date().getFullYear()} Jos'FIT · Fait avec ❤️ en France
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
